import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import {
  Construction as ConstructionIcon
} from '@mui/icons-material';
import { GlassCard } from './ui/GlassComponents';

function PlayerSkills({ displayName, jwt }) {
  return (
    <GlassCard sx={{ p: 4, mt: 3 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '300px',
          textAlign: 'center'
        }}
      >
        <ConstructionIcon
          sx={{
            fontSize: 80,
            color: 'rgba(255, 255, 255, 0.4)',
            mb: 3,
            opacity: 0.6
          }}
        />
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            color: 'rgba(255, 255, 255, 0.95)',
            fontWeight: 600,
            mb: 1
          }}
        >
          Player Skills
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            mb: 1
          }}
        >
          Coming Soon
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: 'rgba(255, 255, 255, 0.5)',
            mt: 1
          }}
        >
          This feature is currently under development
        </Typography>
      </Box>
    </GlassCard>
  );
}

export default PlayerSkills;
